export default "__VITE_ASSET__Cv4Wy2mz__"